'use client';
import DocumentTabView from '@/app/[locale]/(protected)/(dashboard)/ui/DocumentTabView';
import TabTitleRender, { ITabConfig } from '@/app/[locale]/(protected)/(dashboard)/ui/TabTitleRender';
import { DocumentClient } from '@/common/model/apiClient';
import { Document } from '@common/model/apiClient/Document';
import { User } from '@common/model/apiClient/User';
import { TagWithCategory } from '@molecules/TagMenu';
import { useQuery } from '@tanstack/react-query';
import { TabPanel } from 'devextreme-react';
import { useSession } from 'next-auth/react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './AccountDashboard.module.css';

interface DocumentDashboardProps {}

function DocumentDashboard(props: DocumentDashboardProps) {
  const { data: session } = useSession();
  const [search, setSearch] = useState('');
  const [selectedTags, setSelectedTags] = useState<Array<TagWithCategory>>([]);

  const { isFetching: recentDocsFetching, ...userRecentDocsQuery } = useQuery({
    queryKey: [session?.user?.userId, 'user_recent_docs'],
    queryFn: () => User.getRecentDocuments(session?.user?.userId!),
    enabled: !!session?.user?.userId,
  });

  const { isFetching: historyFetching, ...userHistoryQuery } = useQuery({
    queryKey: [session?.user?.userId, 'user_history'],
    queryFn: () => User.getHistory(session?.user?.userId!),
    enabled: !!session?.user?.userId,
  });
  const historyPayload = userHistoryQuery.data?.data?.payload ?? { documents: [], accounts: [] };

  const documentViewHistory = historyPayload.documents.map((doc) => {
    return doc;
  });

  const { isFetching: isTaggedDocsFetching, ...taggedDocsQuery } = useQuery({
    queryKey: ['tagged_docs_search', selectedTags],
    queryFn: () => DocumentClient.list('', {}, { deleted: false, musts: selectedTags.map((t) => ({ terms: { tags: [`${t.id}`] } })) }, 10),
    // () => AccountClient.list('', {}, { deleted: false, musts: accountTagFilters.map((t) => ({ terms: { tags: `${t.id}` } })) }, 10),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    placeholderData: (previousData) => previousData,
    enabled: !!selectedTags.length,
  });

  const taggedDocs = taggedDocsQuery.data?.payload?.map((doc) => doc._source) ?? [];

  const tabsConfig: ITabConfig<Document>[] = [
    {
      icon: 'clock-rotate-left',
      title: <FormattedMessage defaultMessage={'Recently Created Documents'} />,
      data: userRecentDocsQuery.data?.data.payload ?? [],
      id: 'recent-docs',
    },
    {
      icon: 'eye',
      title: <FormattedMessage defaultMessage={'Recently Viewed Documents'} />,
      data: historyPayload.documents,
      id: 'history',
    },
    {
      icon: 'tag',
      title: <FormattedMessage defaultMessage={'Tagged Documents'} description={'Documents filtered by category tags'} />,
      data: !!selectedTags.length ? taggedDocs : [],
      id: 'tags',
      selectedTags,
      setSelectedTags,
      setSearch: (s) => {
        setSearch(s);
      },
      search: search,
    },
  ];

  return (
    <div className={styles.container}>
      <TabPanel dataSource={tabsConfig} itemTitleRender={TabTitleRender} itemComponent={DocumentTabView} animationEnabled={false} />
      {/*<TabPanel dataSource={tabsConfig} itemTitleRender={TabTitleRender} itemComponent={AccountTabView} animationEnabled={true} />*/}
    </div>
  );
}

export default DocumentDashboard;
